import { gql } from "@apollo/client";

const USER_INFO = gql`
  query queryUser($id: Float!) {
    user(id: $id) {
      id
      name
      email
      phone
      password
      token
      token_expires_at
      push_token
      uid
      is_root
      franchise {
        id
        name
      }
    }
  }
`;

export const USER_LOGIN = gql`
  query userLogin($phone: String!, $password: String!, $franchise_id: Float, $is_callcenter: Boolean) {
    userLogin(phone: $phone, password: $password, franchise_id: $franchise_id, is_callcenter: $is_callcenter) {
      id
      name
      email
      phone
      password
      token
      token_expires_at
      push_token
      uid
      is_root
      is_callcenter
      passenger_id
      acting_region_id
      franchise {
        id
        name
      }
      actingRegion {
        id
        name
      }
    }
  }
`;

export const USER_PASSWORD = gql`
  query userPassword($id: Float!, $password: String!, $franchise_id: Float) {
    userPassword(id: $id, password: $password, franchise_id: $franchise_id) {
      id
      name
      email
      phone
      password
      token
      token_expires_at
      push_token
      uid
      is_root
      is_callcenter
      passenger_id
      acting_region_id
      franchise {
        id
        name
      }
      actingRegion {
        id
        name
      }
    }
  }
`;

export const USERS = gql`
  query queryUsers($franchise_id: Float, $acting_region_id: Float, $is_callcenter: Boolean) {
    users(franchise_id: $franchise_id, acting_region_id: $acting_region_id, is_callcenter: $is_callcenter) {
      id
      name
      email
      phone
      token
      token_expires_at
      push_token
      uid
      is_root
      acting_region_id
      is_callcenter
      franchise {
        id
        name
      }
      actingRegion {
        id
        name
      }
    }
    franchises {
      id
      name
    }
    regions(franchise_id: $franchise_id) {
      id
      name
    }
  }
`;

export const USERS_PENDING = gql`
  query queryUsers($franchise_id: Float, $acting_region_id: Float, $is_callcenter: Boolean) {
    users(franchise_id: $franchise_id, acting_region_id: $acting_region_id, is_callcenter: $is_callcenter) {
      id
      name
      email
      phone
      token
      token_expires_at
      push_token
      uid
      is_root
      acting_region_id
      is_callcenter
      franchise {
        id
        name
      }
      actingRegion {
        id
        name
      }
    }
    regions(franchise_id: $franchise_id) {
      id
      name
    }
  }
`;

export const SENDPUSH = gql`
  query querysendPushNotification($title: String!, $message: String!, $topassenger: Boolean, $franchise_id: Float, $acting_region_id: Float) {
    sendPushNotification(title: $title, message: $message, topassenger: $topassenger, franchise_id: $franchise_id, acting_region_id: $acting_region_id) {
      message
    }
  }
`;

export default USER_INFO;
